module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_100000_250000.3bd6a7df.png";